export const LOAD_TAX_STATUS_FAIL = 'LOAD_TAX_STATUS_FAIL';
export const LOAD_TAX_STATUS_REQUEST = 'LOAD_TAX_STATUS_REQUEST';
export const LOAD_TAX_STATUS_SUCCESS = 'LOAD_TAX_STATUS_SUCCESS';

export const UPDATE_TAX_ADDRESS_FAIL = 'UPDATE_TAX_ADDRESS_FAIL';
export const UPDATE_TAX_ADDRESS_REQUEST = 'UPDATE_TAX_ADDRESS_REQUEST';
export const UPDATE_TAX_ADDRESS_SUCCESS = 'UPDATE_TAX_ADDRESS_SUCCESS';
